import store from "../../index.js";
import api from "../../../utils/api";
import ReportConstant from "../../../mixins/report/const/reportConstant.js";
import ReportAcConstant from "../../../mixins/report/const/reportAcConstant.js";
import { ANALYZE_AFTER_TERMS } from "@/enum/score.js";

export const modules = {
  store,
};

export const state = {
  _inquiry: {
    list: [],
    process: null,
  },
  _loanConsultingInquiry: [],
  _error: { code: 0, message: "" },
};

export const mutations = {
  [ReportConstant.ADD_REPORT_BUY_INQUIRY]: (state, response) => {
    state._inquiry = {
      list: [],
      process: null,
    };
    if (response?.items?.length > 0) {
      state._inquiry.list = response.items;
    }
    if (response?.process) {
      state._inquiry.process = response.process;
    }
  },
  [ReportConstant.ADD_REPORT_BUY_INQUIRY_ERROR]: (state, payload) => {
    state._error = { code: 0, message: "" };
    state._error = payload;
  },
  [ReportConstant.ADD_REPORT_BUY_LOAN_CONSULTING_INQUIRY]: (state, response) => {
    state._loanConsultingInquiry = response;
  },
  [ReportConstant.ADD_REPORT_BUY_LOAN_CONSULTING_INQUIRY_ERROR]: (state, payload) => {
    state._error = { code: 0, message: "" };
    state._error = payload;
  },
};

export const actions = {
  async acSendReportBuyInquiry({ commit }, payload) {
    const url = ReportAcConstant.POST_REPORT_BUY_INQUIRY;
    try {
      const res = await api.post(url, {
        content: payload.content,
        user_role_type: payload.user_role_type,
        report_seq: payload.report_seq,
      });
      return res?.data?.code === 0;
    } catch (error) {
      commit(ReportConstant.ADD_REPORT_BUY_INQUIRY_ERROR, error.response.data);
      return false;
    }
  },

  async acGetReportBuyInquiry({ commit }, payload) {
    const url = ReportAcConstant.GET_REPORT_BUY_INQUIRY;
    try {
      const res = await api.get(url, {
        params: payload,
      });
      commit(ReportConstant.ADD_REPORT_BUY_INQUIRY, res?.data?.data);
      return res?.data?.code === 0;
    } catch (error) {
      commit(ReportConstant.ADD_REPORT_BUY_INQUIRY_ERROR, error.response.data);
      return false;
    }
  },

  async acSendReportBuyLoanInquiry({ commit }, payload) {
    const url = ReportAcConstant.POST_REPORT_BUY_LOAN_CONSULTING_INQUIRY;
    try {
      const res = await api.post(url, {
        content: payload.content,
        report_seq: payload.report_seq,
        chat_type: payload.chat_type || "text",
      });
      return res?.data?.code === 0;
    } catch (error) {
      commit(ReportConstant.ADD_REPORT_BUY_LOAN_CONSULTING_INQUIRY_ERROR, error.response.data);
      return false;
    }
  },

  async acGetReportBuyLoanInquiry({ commit }, payload) {
    const url = ReportAcConstant.GET_REPORT_BUY_LOAN_CONSULTING_INQUIRY;
    try {
      const res = await api.get(url, {
        params: payload,
      });
      commit(ReportConstant.ADD_REPORT_BUY_LOAN_CONSULTING_INQUIRY, res?.data?.data);
      return res?.data?.code === 0;
    } catch (error) {
      commit(ReportConstant.ADD_REPORT_BUY_LOAN_CONSULTING_INQUIRY_ERROR, error.response.data);
      return false;
    }
  },
};

export const getters = {
  geCodeFail: state => {
    switch (state._error.code) {
      case 7510:
        return "답변 대기중인 질문이 있습니다.";
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
